import React from "react";
import { ArrowRight } from "lucide-react";

const donationOptions = [
  "Train 1 farmer in climate-smart agriculture",
  "Support a youth training program",
  "Fund a community climate resilience package",
  "Scale impact across communities",
];

const Support = () => {
  return (
    <section className="relative bg-[#F7F4EE] py-16 lg:py-28 px-6 md:px-12 lg:px-20 overflow-hidden">

      {/* SOFT GLOW */}
      <div className="absolute top-[-200px] right-[-120px] w-[500px] h-[500px] bg-green-200/20 blur-3xl rounded-full" />

      <div className="relative max-w-7xl mx-auto">

        {/* TOP SECTION */}
        <div className="grid lg:grid-cols-2 gap-20 items-center">

          {/* LEFT CONTENT */}
          <div>

            <p className="uppercase tracking-[0.35em] text-xs text-green-500 mb-5">
              Support Our Mission
            </p>

            <h2 className="text-3xl lg:text-6xl leading-[1.05] font-medium text-[#1E1E1E] mb-8">
              Your Support Creates
              <span className="block text-green-500">
                Real Change
              </span>
            </h2>

            <div className="space-y-6 text-[#555] lg:text-lg leading-relaxed max-w-xl">
              <p>
                Your donation helps a farmer adopt climate-smart
                practices, equips a young person with skills for
                sustainable employment, and strengthens communities
                against climate shocks.
              </p>

              <p>
                This is not abstract impact - it is visible,
                measurable, and lasting.
              </p>
            </div>

            {/* CTA */}
            <div className="mt-10">
              <a
                href="https://www.linkedin.com/company/anna-foundations/"
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-[#0F172A] hover:bg-green-500 transition-all duration-300 text-white px-8 py-4 rounded-full flex items-center gap-3 tracking-wide w-fit shadow-lg"
              >
                Donate Now

                <span className="group-hover:translate-x-1 transition-transform duration-300">
                  <ArrowRight size={18} />
                </span>
              </a>
            </div>

          </div>

          {/* RIGHT IMAGE */}
          <div className="relative">

            <div className="rounded-[2.5rem] overflow-hidden h-[620px] shadow-2xl relative">

              <img
                src="https://images.unsplash.com/photo-1492496913980-501348b61469?q=80&w=1400&auto=format&fit=crop"
                alt="Climate support"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />

              {/* overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/60 via-transparent to-transparent" />

              {/* border */}
              <div className="absolute inset-0 ring-1 ring-green-400/20 rounded-[2.5rem]" />

            </div>

            {/* FLOATING STAT */}
            <div className="absolute -bottom-8 -left-2 lg:-left-8 bg-white p-8 rounded-[2rem] shadow-2xl max-w-xs border border-green-100">

              <p className="text-3xl font-semibold text-green-500 mb-2">
                Real Change
              </p>

              <p className="text-[#555] leading-relaxed">
                Sustainable impact for farmers, youth, and communities
                facing climate challenges.
              </p>

            </div>

          </div>
        </div>

        {/* SECOND SECTION */}
        <div className="mt-28 lg:mt-36">

          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10 mb-14">

            <div>
              <p className="uppercase tracking-[0.35em] text-xs text-green-500 mb-4">
                Make an Immediate Impact Today
              </p>

              <h3 className="text-3xl lg:text-5xl font-medium text-[#1E1E1E] leading-tight">
                Donation Options
              </h3>
            </div>

            <p className="max-w-lg text-[#666] lg:text-lg leading-relaxed">
              Every contribution directly supports climate resilience,
              sustainable agriculture, and community empowerment.
            </p>

          </div>

          {/* DONATION CARDS */}
          <div className="grid grid-cols-2 md:grid-cols-2 xl:grid-cols-4 gap-3 lg:gap-6">

            {donationOptions.map((item, index) => (
              <a
                key={index}
                href="https://www.linkedin.com/company/anna-foundations/"
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-white rounded-[1.2rem] lg:rounded-[2rem] p-4 lg:p-8 min-h-[170px] lg:min-h-[280px] flex flex-col justify-between border border-green-100 hover:border-green-400 hover:-translate-y-2 transition-all duration-500 shadow-sm hover:shadow-2xl"
              >

                <div>

                  <span className="text-green-500 text-[10px] lg:text-sm tracking-[0.2em] uppercase">
                    Option {index + 1}
                  </span>

                  <h4 className="text-sm lg:text-xl font-medium text-[#1E1E1E] leading-snug mt-3 lg:mt-6">
                    {item}
                  </h4>

                </div>

                <div className="mt-5 lg:mt-10 flex items-center justify-between border-t border-green-100 pt-3 lg:pt-5 text-[#1E1E1E] group-hover:text-green-500 transition-colors duration-300">

                  <span className="tracking-wide text-[11px] lg:text-sm">
                    Donate Now
                  </span>

                  <ArrowRight
                    size={16}
                    className="group-hover:translate-x-1 transition-transform duration-300"
                  />

                </div>

              </a>
            ))}

          </div>

        </div>

      </div>
    </section>
  );
};

export default Support;